import { render } from "./sensor-holdingRegisters-list.vue?vue&type=template&id=1e0ebe15&scoped=true"
import script from "./sensor-holdingRegisters-list.vue?vue&type=script&lang=js"
export * from "./sensor-holdingRegisters-list.vue?vue&type=script&lang=js"

import "./sensor-holdingRegisters-list.vue?vue&type=style&index=0&id=1e0ebe15&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0ebe15"]])

export default __exports__